module.exports = __webpack_public_path__ + "img/cel.48b0e04d.svg";